import * as simulatorServices from "../../../services/SimulatorsServices";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { salvarNegociacao, renovarNegociacao, excluirPreco, getBeneficioFiscal, getTabelaPrecoClienteById } from "./PricesTableServices";
import useCacheMutation from "~hooks/useCacheMutation";

export const useSalvarNegociacao = (data, onSuccess, onErro) => {
  const { mutateCached } = useCacheMutation(
    salvarNegociacao,
    "Salvar Negociação",
    null,
    null,
    null,
    onSuccess,
    onErro
  );

  const handleSave = () => {
    mutateCached(data);
  };

  return handleSave;
};

export const useRenovarNegociacao = (data, onSuccess, onErro) => {
  const { mutateCached } = useCacheMutation(
    renovarNegociacao,
    "Renovar Negociação",
    onSuccess,
    onErro
  );

  const handleSave = () => {
    mutateCached(data);
  };

  return handleSave;
};

export const useExcluirPreco = (dados, onSuccess, onErro) => {
  const { mutateCached } = useCacheMutation(
    excluirPreco,
    "Excluir Negociação",
    null,
    null,
    null,
    onSuccess,
    onErro
  );

  const handleSave = () => {
    mutateCached(dados);
  };

  return handleSave;
};

export const useGetBeneficioFiscal = (beneficioEnabled, clienteId, filialId, produtoId) => {
  const res = useQuery(["beneficio-fiscal", clienteId, filialId, produtoId], () => getBeneficioFiscal(clienteId, filialId, produtoId), {
    enabled: beneficioEnabled,
  });

  const queryClient = useQueryClient();

  const clearCache = () => {
    queryClient.removeQueries(["beneficio-fiscal"]);
  };

  return { ...res, clearCache };
}


export const useGetTabelaPrecoClienteById = (clienteId, tabelaEnabled) => {
  const res = useQuery(["tabela-preco-cliente", clienteId], () => getTabelaPrecoClienteById(clienteId), {
    enabled: tabelaEnabled,
  });

  const queryClient = useQueryClient();

  const clearCache = () => {
    queryClient.removeQueries(["tabela-preco-cliente"]);
  };

  return { ...res, clearCache };
}